
    <p style="width: 350px; margin: 50px auto; border-bottom: 4px solid #f65126;">
     <!--   <mat-icon style="display: inline-block; vertical-align: top;">error</mat-icon> -->
        <span style="display: inline-block; font-weight: bold; font-size: 24px;" translate="msgGuestWebMessage">
        You do not currently have access to MyLion Web.
        </span>
    </p>
    <p style="text-align: center;">
        <app-button (click)="goLogin()"><span translate="btnGoBack">GO BACK</span></app-button>
    </p>
  